import React, { useEffect } from "react";
import { ActionIcon } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useChat } from "./ChatContext";
import ChatConversationList from "./ChatConversationList";
import ChatThread from "./ChatThread";
import ChatNewModal from "./ChatNewModal";
import classes from "./ChatTray.module.css";

export default function ChatTray() {
  const { t } = useTranslation();
  const { open, closeTray } = useChat();

  useEffect(() => {
    if (!open) return undefined;
    function onKey(event) {
      if (event.key === "Escape") closeTray();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [closeTray, open]);

  if (!open) return <ChatNewModal />;

  return (
    <>
      <div className={classes.tray} role="dialog" aria-label={t("chat")}>
        <ActionIcon
          className={classes.collapse}
          variant="filled"
          color="gray"
          radius="xl"
          onClick={closeTray}
          aria-label={t("chat_close")}
        >
          <IconChevronLeft size={16} />
        </ActionIcon>
        <ChatConversationList />
        <ChatThread />
      </div>
      <ChatNewModal />
    </>
  );
}
